import React, { useContext, useEffect, useMemo, useState } from "react";
import logo12 from "../../assets/HealthCare2u_Logo.svg";
import logoprimecare from "../../assets/primecare.svg";
import logout from "../../assets/logout.svg";
import logoutprime from "../../assets/logoutprime.svg";
import healthsideimg from "../../assets/healthsideimg.svg";
import sidemenu from "../../assets/sidemenu.svg";
import productselected from "../../assets/productselected.svg";
import healthproduct from "../../assets/product.svg";
import user from "../../assets/user.svg";
import groups from "../../assets/groups.svg";
import noti from "../../assets/noti.svg";
import reportActive from "../../assets/reports_selected.svg";
import reportInActive from "../../assets/reports_inactive.svg";
import userselcted from "../../assets/userselcted.svg";
import grouselected from "../../assets/grouselected.svg";
import notiselected from "../../assets/notiselected.svg";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginSliceAction } from "../../redux/action/loginSlice";
import { getAdminProfileAction } from "../../redux/action/getAdminProfileSlice";
import { addProductAction } from "../../redux/action/addProductSlice";
import { getProductFeaturesAction } from "../../redux/action/getproductFeaturesSlice";
import { getGroupProductFeatureContentAction } from "../../redux/action/getGroupProductFeatureContent";
import { getProductFeatureContentAction } from "../../redux/action/getProductFeatureContentSlice";
import { fileUploadAction } from "../../redux/action/fileUpload";
import { ThemeContext } from "../../common/themeContext";
import { BrandChangeModal } from "../../components/BrandChangeModal/BrandChangeModal";
import { removeItem } from "../../common/localStorage";
import emailFillIcon from "../../assets/emailFillIcon.svg";
import emailIcon from "../../assets/emailIcon.svg";
import releaseFillIcon from "../../assets/releaseFillIcon.svg";
import releaseIcon from "../../assets/releaseIcon.svg";
import dashboardFillIcon from "../../assets/dashboardFillIcon.svg";
import dashboardIcon from "../../assets/dashboardIcon.svg";
import qceFillIcon from "../../assets/qceFillIcon.svg";
import qceIcon from "../../assets/qceIcon.svg";
import LogoutModal from "./LogoutModal";
import aiCampaigns from "../../assets/aiCampaign.svg";
import aiCampaignsSelected from "../../assets/aiCampaignSelected.svg";
import arrowUpIcon from "../../assets/arrow-up.svg";
import { useAdminPermissions } from "../../hooks/useAdminPermissions";

const Sidebar = ({ children }) => {
  const { toggleTheme, brandId } = useContext(ThemeContext);
  const {
    defaultRoute: profileDefaultRoute,
    isSidebarReady: isMenuReady,
    canAccessSidebarItem,
  } = useAdminPermissions();
  const visibleSidebarItems = useMemo(
    () => ({
      dashboard: canAccessSidebarItem("dashboard"),
      products: canAccessSidebarItem("products"),
      aiCampaigns: canAccessSidebarItem("aiCampaigns"),
      users: canAccessSidebarItem("users"),
      groups: canAccessSidebarItem("groups"),
      notifications: canAccessSidebarItem("notifications"),
      emailTemplates: canAccessSidebarItem("emailTemplates"),
      qceTemplates: canAccessSidebarItem("qceTemplates"),
      releaseDocuments: canAccessSidebarItem("releaseDocuments"),
      adminManagement: canAccessSidebarItem("adminManagement"),
    }),
    [canAccessSidebarItem],
  );
  const defaultRoute = profileDefaultRoute ?? "/";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  const [isActive, setIsActive] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isAiCampaignsOpen, setIsAiCampaignsOpen] = useState(false);

  useEffect(() => {
    const isOnAiCampaignRoute =
      location?.pathname === "/ai-campaigns" ||
      location?.pathname?.startsWith("/ai-campaigns/");

    if (isOnAiCampaignRoute) {
      setIsAiCampaignsOpen(true);
    }
  }, [location?.pathname]);

  const handleAiCampaignsClick = () => {
    setIsAiCampaignsOpen(!isAiCampaignsOpen);
  };

  const handleItemClick = (path) => {
    if (!path.startsWith("/ai-campaigns")) {
      setIsAiCampaignsOpen(false);
    }
    navigate(path);
  };

  // Logout modal state
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const handleLogoutClick = () => setShowLogoutModal(true);
  const handleLogoutYes = () => {
    setShowLogoutModal(false);
    dispatch(loginSliceAction.loginDetailsSliceReset());
    dispatch(getAdminProfileAction.getAdminProfileInfoReset());
    removeItem("token");
    removeItem("productId");
    navigate("/");
  };
  const handleLogoutNo = () => setShowLogoutModal(false);

  const handleModalYes = () => {
    toggleTheme();
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handledashboardSideBar =
    location?.pathname === "/dashboard"

  const handleProductSideBar =
    location?.pathname === "/product" ||
    location?.pathname === "/addproduct" ||
    location.pathname === "/edit-product" ||
    location.pathname === "/view-product";

  const handleActiveUserSideBar =
    location?.pathname === "/user" || location?.pathname === "/userTemp";

  const handleGroupSideBar =
    location?.pathname === "/groups" ||
    location?.pathname === "/manage-member" ||
    location?.pathname === "/edit-group-product";

  const handleNotificationSideBar =
    location?.pathname === "/notification" ||
    location?.pathname === "/create-notification";
  // const handleReportSideBar = location?.pathname === "/reports";

  const handleEmailTemplates =
    location?.pathname === "/email-templates" ||
    location?.pathname === "/create-email-template" ||
    location?.pathname === "/manage-email-template";
  const handleQceTemplates = location?.pathname === "/qce-templates" || location?.pathname === "/manage-qce-templates";
  const handleReleaseDocuments = location?.pathname === "/release-documents";
  const handleAdminManagement =
    location?.pathname === "/admins" ||
    location?.pathname?.startsWith("/admins/");
  const handleAiCampaignsSideBar =
    location?.pathname === "/ai-campaigns" ||
    location?.pathname?.startsWith("/ai-campaigns/");

  /** Prefixes are matched with exact segment boundaries (path or path + "/…"). */
  const pathnameMatchesAiCampaignPrefix = (pathname, prefix) =>
    pathname === prefix || pathname.startsWith(`${prefix}/`);

  const aiCampaignsMenuItems = [
    {
      label: "Campaign List",
      path: "/ai-campaigns/campaign-list",
      activePathPrefixes: [
        "/ai-campaigns/manage-ai-campaign",
        "/ai-campaigns/campaign-details",
      ],
    },
    {
      label: "Material",
      path: "/ai-campaigns/Material",
      activePathPrefixes: [
        "/ai-campaigns/material",
        "/ai-campaigns/manage-material",
        "/ai-campaigns/add-material",
      ],
    },
    // { label: "Campaign Config", path: "/ai-campaigns/campaign-config" },
    { label: "Terms & Conditions", path: "/ai-campaigns/terms-conditions" },
    {
      label: "Enrollment Agreement",
      path: "/ai-campaigns/enrollment-agreement",
      activePathPrefixes: ["/ai-campaigns/enrollment-agreement-view"],
    },
  ];

  const isAiCampaignItemActive = (item) => {
    const pathname = location?.pathname || "";
    if (pathname === "/ai-campaigns") {
      return item.path === "/ai-campaigns/campaign-list";
    }
    const prefixes = [item.path, ...(item.activePathPrefixes || [])];
    return prefixes.some((p) => pathnameMatchesAiCampaignPrefix(pathname, p));
  };

  return (
    <>
      <div
        style={{ display: "flex", height: "100vh", overflow: "scroll initial" }}
      >
        <div className={`sidebar ${isSidebarOpen ? "" : "toggled"}`}>
          <div className="sidebar-header">
            <div className="head-div">
              <span className="icon-suffix" onClick={toggleSidebar}>
                <img src={healthsideimg} className=" logouthealth" alt="" />
                <img src={sidemenu} className="logoutprime" alt="" />
              </span>
              <span
                className="head-text"
                onClick={() => handleItemClick(defaultRoute)}
              >
                <Link className="text-decoration-none">
                  <img
                    src={logo12}
                    className="h-100 w-100 healthcareImg"
                    alt="Healthcare Logo"
                  />
                  <img
                    src={logoprimecare}
                    className="h-100 w-100 primecareImg"
                    alt="Primecare Logo"
                  />
                </Link>
              </span>
            </div>
          </div>
          <div className="sidebar-content">
            <ul className="list-unstyled">
              {!isMenuReady ? (
                <li
                  className="sidebar-menu-placeholder"
                  aria-hidden="true"
                  style={{ minHeight: "320px", pointerEvents: "none" }}
                />
              ) : (
                <>
              {visibleSidebarItems.dashboard && (
              <li
                className={`sc-cfxfcM hQSxZz d-flex  ${handledashboardSideBar ? "active" : ""
                  }`}
                onClick={() => {
                  handleItemClick("/dashboard");
                  dispatch(addProductAction.addProductSliceInfoReset());
                  dispatch(
                    getProductFeaturesAction.getProductFeaturesInfoReset()
                  );
                  dispatch(
                    getGroupProductFeatureContentAction.getGroupProductFeatureContentReset()
                  );
                  dispatch(
                    getProductFeatureContentAction.getProductFeatureContentInfoReset()
                  );
                  dispatch(fileUploadAction.fileUploadInfoReset());
                  removeItem("productId");
                }}
              >
                <div className="hoverimges">
                  <img className="normalimg" src={dashboardIcon} alt="" />

                  <img className="selectimg" src={dashboardFillIcon} alt="" />
                </div>
                <span className="item-content">Dashboard</span>
              </li>
              )}
              {visibleSidebarItems.products && (
              <li
                className={`sc-cfxfcM hQSxZz d-flex  ${handleProductSideBar ? "active" : ""
                  }`}
                onClick={() => {
                  handleItemClick("/product");
                  dispatch(addProductAction.addProductSliceInfoReset());
                  dispatch(
                    getProductFeaturesAction.getProductFeaturesInfoReset()
                  );
                  dispatch(
                    getGroupProductFeatureContentAction.getGroupProductFeatureContentReset()
                  );
                  dispatch(
                    getProductFeatureContentAction.getProductFeatureContentInfoReset()
                  );
                  dispatch(fileUploadAction.fileUploadInfoReset());
                  removeItem("productId");
                }}
              >
                <div className="hoverimges">
                  <img className="normalimg" src={healthproduct} alt="" />

                  <img className="selectimg" src={productselected} alt="" />
                </div>
                <span className="item-content">Products</span>
              </li>
              )}
              {visibleSidebarItems.aiCampaigns && brandId === 2 && (
                <>

                  <li
                    className={`sc-cfxfcM hQSxZz d-flex ${isAiCampaignsOpen ? "ai-campaigns-open " : ""} ${handleAiCampaignsSideBar ? "active" : ""
                      }`}
                    onClick={handleAiCampaignsClick}
                  >
                    <div className="d-flex flex-grow-1 align-items-center ai-campaigns-row">
                      <div className="hoverimges">
                        <img className="normalimg" src={aiCampaigns} alt="" />
                        <img className="selectimg" src={aiCampaignsSelected} alt="" />
                      </div>
                      <div className="d-flex align-items-center justify-content-between w-100 pr-16">
                        <span className="item-content">AI Campaigns</span>
                        <img src={arrowUpIcon} style={{ transform: isAiCampaignsOpen ? "rotate(0deg)" : "rotate(180deg)", transition: "transform 0.3s ease" }} alt="" />
                      </div>
                    </div>

                  </li>
                  <div
                    className={`ai-campaigns-dropdown ${isAiCampaignsOpen ? "open" : "closed"}`}
                  >
                    {aiCampaignsMenuItems.map((item) => (
                      <div
                        key={item.path}
                        className={`ai-campaigns-dropdown-item ${isAiCampaignItemActive(item) ? "active" : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleItemClick(item.path);
                        }}
                      >
                        <span className="ai-campaigns-dropdown-item-label">{item.label}</span>
                      </div>
                    ))}
                  </div>
                </>
              )}
              {visibleSidebarItems.users && (
              <li
                className={`sc-cfxfcM hQSxZz d-flex  ${handleActiveUserSideBar ? "active" : ""
                  }`}
                onClick={() => {
                  handleItemClick("/user");
                  dispatch(addProductAction.addProductSliceInfoReset());
                  dispatch(
                    getGroupProductFeatureContentAction.getGroupProductFeatureContentReset()
                  );
                  dispatch(
                    getProductFeaturesAction.getProductFeaturesInfoReset()
                  );
                  dispatch(
                    getProductFeatureContentAction.getProductFeatureContentInfoReset()
                  );
                  dispatch(fileUploadAction.fileUploadInfoReset());
                  removeItem("productId");
                }}
              >
                <div className="hoverimges">
                  <img className="normalimg" src={user} alt="" />

                  <img className="selectimg" src={userselcted} alt="" />
                </div>
                <span className="item-content">Users</span>
              </li>
              )}
              {visibleSidebarItems.groups && (
              <li
                className={`sc-cfxfcM hQSxZz d-flex  ${handleGroupSideBar ? "active" : ""
                  }`}
                onClick={() => {
                  handleItemClick("/groups");
                  dispatch(addProductAction.addProductSliceInfoReset());
                  dispatch(
                    getGroupProductFeatureContentAction.getGroupProductFeatureContentReset()
                  );
                  dispatch(
                    getProductFeaturesAction.getProductFeaturesInfoReset()
                  );
                  dispatch(
                    getProductFeatureContentAction.getProductFeatureContentInfoReset()
                  );
                  dispatch(fileUploadAction.fileUploadInfoReset());
                  removeItem("productId");
                }}
              >
                <div className="hoverimges">
                  <img className="normalimg" src={groups} alt="" />

                  <img className="selectimg" src={grouselected} alt="" />
                </div>
                <span className="item-content">Groups</span>
              </li>
              )}
              {visibleSidebarItems.notifications && (
              <li
                className={`sc-cfxfcM hQSxZz d-flex  ${handleNotificationSideBar ? "active" : ""
                  }`}
                onClick={() => {
                  handleItemClick("/notification");
                  dispatch(addProductAction.addProductSliceInfoReset());
                  dispatch(
                    getGroupProductFeatureContentAction.getGroupProductFeatureContentReset()
                  );
                  dispatch(
                    getProductFeaturesAction.getProductFeaturesInfoReset()
                  );
                  dispatch(
                    getProductFeatureContentAction.getProductFeatureContentInfoReset()
                  );
                  dispatch(fileUploadAction.fileUploadInfoReset());
                  removeItem("productId");
                }}
              >
                <div className="hoverimges">
                  <img className="normalimg" src={noti} alt="" />

                  <img className="selectimg" src={notiselected} alt="" />
                </div>
                <span className="item-content">Notifications</span>
              </li>
              )}

              {visibleSidebarItems.emailTemplates && (
              <li
                className={`sc-cfxfcM hQSxZz d-flex  ${handleEmailTemplates ? "active" : ""
                  }`}
                onClick={() => {
                  handleItemClick("/email-templates");
                  dispatch(addProductAction.addProductSliceInfoReset());
                  dispatch(
                    getGroupProductFeatureContentAction.getGroupProductFeatureContentReset()
                  );
                  dispatch(
                    getProductFeaturesAction.getProductFeaturesInfoReset()
                  );
                  dispatch(
                    getProductFeatureContentAction.getProductFeatureContentInfoReset()
                  );
                  dispatch(fileUploadAction.fileUploadInfoReset());
                  removeItem("productId");
                }}
              >
                <div className="hoverimges">
                  <img className="normalimg" src={emailIcon} alt="" />

                  <img className="selectimg" src={emailFillIcon} alt="" />
                </div>
                {/* <span className="item-content">Email Template</span> */}
                <span className="item-content">Welcome Email Template</span>
              </li>
              )}
              {brandId === 2 && visibleSidebarItems.qceTemplates && (
              <li
                className={`sc-cfxfcM hQSxZz d-flex  ${handleQceTemplates ? "active" : ""
                  }`}
                onClick={() => {
                  handleItemClick("/qce-templates");

                }}
              >
                <div className="hoverimges">
                  <img className="normalimg" src={qceIcon} alt="" />

                  <img className="selectimg" src={qceFillIcon} alt="" />
                </div>
                <span className="item-content">QCE Templates</span>
              </li>
              )}
              {visibleSidebarItems.releaseDocuments && (
              <li
                className={`sc-cfxfcM hQSxZz d-flex  ${handleReleaseDocuments ? "active" : ""
                  }`}
                onClick={() => {
                  handleItemClick("/release-documents");
                  dispatch(addProductAction.addProductSliceInfoReset());
                  dispatch(
                    getGroupProductFeatureContentAction.getGroupProductFeatureContentReset()
                  );
                  dispatch(
                    getProductFeaturesAction.getProductFeaturesInfoReset()
                  );
                  dispatch(
                    getProductFeatureContentAction.getProductFeatureContentInfoReset()
                  );
                  dispatch(fileUploadAction.fileUploadInfoReset());
                  removeItem("productId");
                }}
              >
                <div className="hoverimges">
                  <img className="normalimg" src={releaseIcon} alt="" />

                  <img className="selectimg" src={releaseFillIcon} alt="" />
                </div>
                <span className="item-content">Release Documents</span>
              </li>
              )}
              {visibleSidebarItems.adminManagement && (
              <li
                className={`sc-cfxfcM hQSxZz d-flex  ${handleAdminManagement ? "active" : ""
                  }`}
                onClick={() => {
                  handleItemClick("/admins");
                  dispatch(addProductAction.addProductSliceInfoReset());
                  dispatch(
                    getGroupProductFeatureContentAction.getGroupProductFeatureContentReset()
                  );
                  dispatch(
                    getProductFeaturesAction.getProductFeaturesInfoReset()
                  );
                  dispatch(
                    getProductFeatureContentAction.getProductFeatureContentInfoReset()
                  );
                  dispatch(fileUploadAction.fileUploadInfoReset());
                  removeItem("productId");
                }}
              >
                <div className="hoverimges">
                  <img className="normalimg" src={user} alt="" />

                  <img className="selectimg" src={userselcted} alt="" />
                </div>
                <span className="item-content">Admin Management</span>
              </li>
              )}
              {/* {brandId === 2 && ( */}
              {/* <li
                  className={`sc-cfxfcM hQSxZz d-flex  ${
                    handleReportSideBar ? "active" : ""
                  }`}
                  onClick={() => {
                    handleItemClick("/reports");
                    dispatch(addProductAction.addProductSliceInfoReset());
                    dispatch(
                      getGroupProductFeatureContentAction.getGroupProductFeatureContentReset()
                    );
                    dispatch(
                      getProductFeaturesAction.getProductFeaturesInfoReset()
                    );
                    dispatch(
                      getProductFeatureContentAction.getProductFeatureContentInfoReset()
                    );
                    dispatch(fileUploadAction.fileUploadInfoReset());
                    removeItem("productId");
                  }}
                >
                  <div className="hoverimges">
                    <img className="normalimg" src={reportInActive} alt="" />

                    <img className="selectimg" src={reportActive} alt="" />
                  </div>
                  <span className="item-content">Reports</span>
                </li> */}
              {/* )} */}
                </>
              )}
            </ul>
          </div>
          <div className="sidebar-footer text-center">
            <button
              type="button"
              className=" btn-lg btn-toggle rounded-pill"
              data-toggle="button"
              aria-pressed="false"
              autoComplete="off"
              onClick={() => setIsModalOpen(true)}
            >
              <div
                className={`handle active ${isActive ? "active" : ""}`}
              ></div>
            </button>
            <hr />
            <div
              className="logout-link logout d-flex justify-content-center"
              onClick={handleLogoutClick}
            >
              <img src={logout} className="logoutprime" alt="Logout" />
              <img src={logoutprime} className="logouthealth" alt="Logout" />
              <span>Logout</span>
            </div>
          </div>
        </div>
        {children}
      </div>
      {isModalOpen && (
        <BrandChangeModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          handleModalYes={handleModalYes}
          handleCancel={handleCancel}
        />
      )}
      <LogoutModal show={showLogoutModal} onYes={handleLogoutYes} onNo={handleLogoutNo} />
    </>
  );
};

export default Sidebar;
